export const ALARM_LOGS_NS = 'components/AlarmLogs';

export const i18n = {
  en: {
    modals: {
      export: {
        title: 'You are about to export the alarm logs',
        message:
          'If you have selected any filters in the alarm logs screen, these will be applied to your exported data.',
        exportingMessage: 'Exporting data...',
        confirmText: 'Export',
        cancelText: 'Cancel',
        error: {
          message: 'Failed to export the file.',
        },
      },
    },
  },
};
